import { useNavigate } from "@tanstack/react-router";
import type { Row } from "@tanstack/react-table";

import { DataTable, DataTablePagination } from "@/components/DataTable";
import { CertificationKind } from "@/routes/_staff/certification/-constants";

import { useCertificationsTable } from "../-hooks/useCertificationsTable";
import { CertificationsTableRow } from "../-query/type";

export const CertificationsDataTable = ({ personId }: { personId: string }) => {
  const { table, displayState, count } = useCertificationsTable(personId);
  const navigate = useNavigate();
  const handleRowClick = (row: Row<CertificationsTableRow>) => {
    const path =
      row.original.certificationKind === CertificationKind.BASE
        ? "base-certifications"
        : row.original.certificationKind === CertificationKind.SPECIALTY
          ? "specialty-certifications"
          : "handling-certifications";
    navigate({
      to: `/person/$id/certifications/${path}/$personCertificationInformationId`,
      params: {
        id: personId,
        personCertificationInformationId: row.original.id,
      },
    });
  };

  return (
    <>
      <div className="overflow-auto flex-1 min-h-0">
        <DataTable
          table={table}
          displayState={displayState}
          onRowClick={handleRowClick}
        />
      </div>
      <DataTablePagination table={table} totalCount={count} />
    </>
  );
};
